// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2YCB4","legacyBtn":"MutateMid_legacyBtn__1i54g"};